import React from 'react';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

import styles from './Profile.module.sass';
import { IEventListItem } from '@types';
import { paths } from 'router/paths';

const Profile: React.FC<{ event: IEventListItem }> = ({ event }) => {
  const navigate = useNavigate();
  const navigateToEdit = (id: string) => {
    navigate(paths.EVENTS_MODIFY_PATH.replace(':id', id));
  };
  return (
    <div className={styles.profile}>
      <div className={styles.details}>
        <div className={styles.wrap}>
          <div className={cn('h4', styles.man)}>{event.title}</div>
          <div className={styles.info}>თარიღი - {event.date}</div>
          <div className={styles.info}>ბილეთების დაწყება - {event.joinRequestStartDate}</div>
          <div className={styles.info}>ბილეთების დასრულება - {event.joinRequestEndDate}</div>
        </div>
      </div>
      <div className={styles.contacts}>
        <button onClick={() => navigateToEdit(event.id)} className={cn('button', styles.button)}>
          რედაქტირება
        </button>
      </div>
    </div>
  );
};

export default Profile;
